<ng-container *ngIf="processService.isNavigation">
  <button
    *ngIf="(currentStep$ | async) === 0"
    (click)="modalService.openModal(modalType.GDPR)"
    nxPlainButton
    type="button"
    class="home-panel-left-button">
    <span nxCopytext="small">{{ (isAppAgentOrTravelAgency ? "home.modalLabelAgent" : "home.modalLabel") | translate }}</span>
    <nx-icon name="chevron-right-small" class="nx-margin-right-2xs"></nx-icon>
  </button>

  <app-fab (emitComponentLoaded)="updateElementsRef($event, 'fab')" [buttonsOverlap]="buttonsOverlap" [fabButtonBottomPosition]="fabButtonBottomPosition"/>

  <div class="navigation" *ngIf="nextStepVisible$ | async" [ngClass]="{ 'sticky-navigation': !(isOfferPriceBoxVisible$ | async) && (currentStep$ | async) === 2}">
    <p *ngIf="displayConclusionNotice$ | async" nxCopytext="normal" class="nx-margin-bottom-2m navigation-agent-notice">
      {{ 'conclusion_agent.notice' | translate }}
    </p>
    <app-navigation-row
      #navigationRow
      [offerValue]="offerValue$ | async"
      [processOfferVisible]="processOfferVisible$ | async"
      [buttonLabel]="buttonLabel$ | async"
      (emitGoToNextStep)="goToNextStep()"
      (emitComponentLoaded)="updateElementsRef($event, 'navRow')"/>
  </div>
</ng-container>
